/**
 * Collection & search pages: steadier sticky Filter / Sort bar on mobile.
 *
 * The theme decides whether the bar is "stuck" by checking that the bar itself is exactly at
 * 56px (60px on tablet) from the top. While an iPhone is momentum-scrolling that position can
 * read a fraction of a pixel off, so the "4153 Results" row kept appearing and disappearing
 * (the page "shivers"). Here the decision is made from the invisible marker just above the bar
 * (it scrolls normally, so its position is reliable) with a margin, so it can't flip back and forth.
 */
(function () {
  function patch(el) {
    if (el.__stickyFixReady || !el.topContainer || !el.scrollSentinel || !el.scrollTarget) return;
    el.__stickyFixReady = true;

    // Stop the theme's own scroll handler; ours does the same job without the flicker.
    el.scrollTarget.removeEventListener('scroll', el.handleStickyScroll);

    var top = el.topContainer;
    var sentinel = el.scrollSentinel;
    var scroller = el.scrollContainer;
    var STICKY_CLASS = 's-main-collection__top-container--sticky';
    var UP_CLASS = 's-main-collection__top-container--scroll-up';
    var MARGIN = 48; // px of scrolling needed before the bar can switch back
    var DIRECTION_DISTANCE = 12; // px of scrolling in one direction before "scroll up" changes
    var ticking = false;
    var isSticky = top.classList.contains(STICKY_CLASS);
    var goingUp = top.classList.contains(UP_CLASS);
    var turningPoint = currentY();

    function currentY() {
      return el.scrollTarget === window ? window.scrollY || window.pageYOffset || 0 : scroller.scrollTop;
    }

    function stickyOffset() {
      return window.innerWidth >= 768 ? 60 : 56;
    }

    function update() {
      ticking = false;
      var offset = stickyOffset();
      var markerTop = sentinel.getBoundingClientRect().top;

      if (!isSticky && markerTop <= offset) {
        isSticky = true;
      } else if (isSticky && markerTop > offset + MARGIN) {
        isSticky = false;
      }
      top.classList.toggle(STICKY_CLASS, isSticky);

      var y = currentY();
      if (el.isDeluxe) el.classList.toggle('s-main-collection--scrolled', y > 20);

      // Scroll direction (only shows the applied-filter chips again when scrolling up).
      // turningPoint = furthest point reached in the current direction; switch only after
      // moving DIRECTION_DISTANCE back from it, so small wobbles are ignored.
      if (goingUp) {
        if (y > turningPoint + DIRECTION_DISTANCE) {
          goingUp = false;
          turningPoint = y;
          top.classList.remove(UP_CLASS);
        } else {
          turningPoint = Math.min(turningPoint, y);
        }
      } else if (y < turningPoint - DIRECTION_DISTANCE) {
        goingUp = true;
        turningPoint = y;
        top.classList.add(UP_CLASS);
      } else {
        turningPoint = Math.max(turningPoint, y);
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    el.scrollTarget.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function init() {
    document.querySelectorAll('s-main-collection').forEach(patch);
  }

  if (window.customElements) {
    customElements.whenDefined('s-main-collection').then(function () {
      // the theme sets up its sticky bar while the element starts; run right after
      requestAnimationFrame(init);
    });
  }
})();
